import { PARTNERSHIPS_EMAIL } from '@/content/partners/data'
import type { InquiryFields } from '@/content/partners/types'

export interface InquiryDraft {
    subject: string
    body: string
}

/**
 * The single source of the draft's format. Three surfaces render it — the mailto
 * URL, the fallback panel's text, and the copy control — and they must never
 * drift apart, so all three read this.
 */
export function buildInquiryDraft({ company, details, ref }: InquiryFields): InquiryDraft {
    const bodyParts = [details?.trim(), ref ? `Referred via: ${ref}` : undefined].filter(
        (part): part is string => Boolean(part),
    )
    return {
        subject: `Partnership inquiry — ${company}`,
        body: bodyParts.join('\n\n'),
    }
}

/**
 * The prefilled draft as a mailto URL. Line breaks are normalized to CRLF —
 * RFC 6068's body separator; a bare LF renders as a single run-on line in
 * several mail clients.
 */
export function buildInquiryMailto(fields: InquiryFields): string {
    const { subject, body } = buildInquiryDraft(fields)
    const params = [`subject=${encodeURIComponent(subject)}`]
    if (body) {
        params.push(`body=${encodeURIComponent(body.replace(/\r?\n/g, '\r\n'))}`)
    }
    return `mailto:${PARTNERSHIPS_EMAIL}?${params.join('&')}`
}
